var Polygon = require('./polygon');

/**
 * Greiner-Hormann polygon clipping
 * @license MIT
 * @author Milevski Alexander (c) 2014
 * @preserve
 */


/**
 * Clip driver
 * @api
 * @param  {Array.<Array.<Number>>} polygonA
 * @param  {Array.<Array.<Number>>} polygonB
 * @param  {Boolean}                sourceForwards
 * @param  {Boolean}                clipForwards
 * @return {Array.<Array.<Number>>}
 */
module.exports = function(polygonA, polygonB, eA, eB) {
    var result, source = new Polygon(polygonA),
        clip = new Polygon(polygonB),
        result = source.clip(clip, eA, eB);

    return result;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/greiner-hormann/src/clip.js
// module id = 305
// module chunks = 0